import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";
import api, { getAuthToken } from "../../api_interceptor/api";

const DashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [appVersion, setAppVersion] = useState("");
  const navigate = useNavigate();
  const userData = useSelector((state) => state.user.userData);

  useEffect(() => {
    // Check if user is authenticated
    const token = getAuthToken();
    const isAuthenticated = userData || token;

    if (!isAuthenticated) {
      // Clear any stale data
      localStorage.clear();
      sessionStorage.clear();
      // Redirect to login
      navigate("/", { replace: true });
    }
  }, [userData, navigate]);

  useEffect(() => {
    api.post("api/GetCurrentVersion", {
      Product: "CMS",
      Application: "CMS Web",
    })
      .then((response) => {
        if (response.data?.StatusCode === 1 && response.data?.Data?.Version) {
          setAppVersion(response.data.Data.Version);
        }
      })
      .catch(() => {
        // Keep dashboard usable if version lookup fails.
      });
  }, []);

  // Don't render protected content if not authenticated
  const token = getAuthToken();
  const isAuthenticated = userData || token;
  
  if (!isAuthenticated) {
    return null; // Will redirect in useEffect
  }

  return (
  <div className="h-screen flex flex-col overflow-hidden">
    <Header onMenuClick={() => setIsSidebarOpen(prev => !prev)} />

    <div className="flex flex-1 min-h-0 overflow-hidden">
      <Sidebar isOpen={isSidebarOpen} />

      <div className="flex-1 flex flex-col min-h-0">
        <main className="flex-1 min-h-0 p-4 bg-light transition-all duration-300">
          <Outlet />
        </main>

<footer className="px-4 pb-2 text-[11px] text-slate-500 text-right bg-light">
  {appVersion}
</footer>

      </div>
    </div>
  </div>
);
 
};

export default DashboardLayout;
